




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import DxButton from 'devextreme-vue/button';
import BaseMixin from '@/components/mixins/base';
import { apiService } from '@/container';

@Component({
  components: {
    DxButton
  }
})
export default class ChartsListPanelItem extends BaseMixin {

  @Prop({ type: String, required: true }) idChart!: string;
  @Prop({ type: String, required: true }) chartName!: string;
  @Prop({ type: String, required: true }) idDashboard!: string;
  @Prop({ type: String, default: null }) idSharedChart!: string | null;

  get isShared(): boolean {
    return this.idSharedChart !== null;
  }

  async onAddClick() {
    await apiService.post('dashboards', `${this.idDashboard}/addChart`, { idChart: this.idChart });
    this.$emit('dashboard:chart-added');
  }

  async onChartDeleteClick() {
    this.confirmDialog(this.$t('chart.disable.warning'), async () => {
      await apiService.post('charts', `${this.idChart}/disable`);
      this.$emit('dashboard:chart-disabled');
    });
  }

  onChartEditClick() {
    this.$router.push({
      name: 'charts.create',
      query: {
        idChart: this.idChart,
        idDashboard: this.idDashboard
      }
    });
  }

}

